import { createActions } from 'redux-actions'

import { NAME } from './constants'

const actions = createActions({
  [NAME]: {
    SET: undefined,
    SET_INITIAL_VALUES: undefined,
    INITIALIZE: undefined,
    UPDATE_INITIAL_VALUES: undefined,
    SUBMIT: undefined,
  },
})

export default actions[NAME]



// WEBPACK FOOTER //
// ../source/views/Login/actions.js